import { Link } from "react-router-dom";
import { getAvatarProfilePath, getUserProfilePath } from "../../utils/profilePaths";

/** Clickable display name — /creator/:handle or /fan/:userId */
export default function ProfileNameLink({
  user,
  userId,
  isCreator,
  handle,
  children,
  className = "",
  onClick,
}) {
  const profileUser = user || { uid: userId, isCreator, handle };
  const to = user?.uid || user?.id
    ? getUserProfilePath(user)
    : getAvatarProfilePath(profileUser);

  if (!to) {
    return <span className={className}>{children}</span>;
  }

  return (
    <Link to={to} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
